import "./MoqMessage.scss";

import * as React from "react";
import { FormattedMessage } from "react-intl";
import { Well } from "react-bootstrap";
import { getFilteredMessages, jsxWithIntl } from "../../i18n/IntlRootMixin";
import ErrorBoundary from "../ErrorBoundary";

type Props = {
    minOrderQuantity: number | null | undefined;
    isWeightArticle: boolean;
    displayPopover: boolean;
};

const phraseProject = "EVALUATE";
const neededTranslationMessages = ["PV_MOQ_MINIMUM_NOT_REACHED_KG", "PV_MOQ_MINIMUM_NOT_REACHED"];
const filteredMessages = getFilteredMessages(phraseProject, neededTranslationMessages);
// Exported for testing
export function MoqMessageUntranslated(props: Props) {
    if (!props?.displayPopover || !props?.minOrderQuantity) {
        return null;
    }

    const messageId = props.isWeightArticle ? "PV_MOQ_MINIMUM_NOT_REACHED_KG" : "PV_MOQ_MINIMUM_NOT_REACHED";
    const moqMessage = (
        <FormattedMessage
            id={messageId}
            values={{
                moq: props.minOrderQuantity
            }}
        />
    );
    return (
        <div className="sd-shared--moq-panel">
            <Well className="sd-shared--panel-well well-sm background-notification-warning well">
                <div className="sd-shared--panel-icon">
                    <i className="icon-warning" />
                </div>
                <div className="sd-shared--panel-content">{moqMessage}</div>
            </Well>
        </div>
    );
}

export default function MoqMessage(props: Props) {
    return (
        <ErrorBoundary>
            <>{jsxWithIntl(<MoqMessageUntranslated {...props} />, phraseProject, filteredMessages)}</>
        </ErrorBoundary>
    );
}
